import type { ModelsResolver } from "@/models/resolvers";
import { revisionDefaultFields } from "@/models/resolvers";
import { useLogger } from "@/composables/logger";
import { useCacheOperations, resolveNestedList } from "@/composables/cache";
import { postgresToJsonArray } from "@/utils/utils-dependent";

const { info: logInfo } = useLogger("PUMPS_XREF_RESOLVER");

export default {
  queries: {
    scenario_equipment_xref_pumps: {
      pump: (parent, args, cache, info) => {
        return parent.pump_id
          ? { __typename: "pumps", id: parent.pump_id }
          : null;
      },
      xref_housings: (parent, args, cache, info) => {
        return resolveNestedList(
          parent.id,
          cache,
          "scenario_equipment_xref_pumps",
          cache.keyOfField("xref_housings", args) || "xref_housings",
          "scenario_equipment_xref_housings"
        );
      }
    }
  },
  optimistic: {
    insert_revisions_scenario_equipment_xref_pumps_revisions(
      vars,
      cache,
      info
    ) {
      logInfo("Optimistic", { vars, cache, info });
      return {
        __typename:
          "revisions_scenario_equipment_xref_pumps_revisions_mutation_response",
        returning: vars.objects.map(object => ({
          id: object.id,
          __typename: "revisions_scenario_equipment_xref_pumps_revisions",
          scenario_equipment_xref_pumps_view: {
            __typename: "scenario_equipment_xref_pumps",
            pump: null,
            ...object,
            ...revisionDefaultFields(object),
            housings_order: postgresToJsonArray(
              object.housings_order as unknown as string
            )
          }
        }))
      };
    }
  },
  updates: {
    insert_revisions_scenario_equipment_xref_pumps_revisions(
      result,
      args,
      cache,
      info
    ) {
      logInfo("Mutation", { result, args, cache, info });

      args.objects.forEach(object => {
        const { handleCacheUpdate } = useCacheOperations({
          cache,
          object,
          typename: "scenario_equipment_xref_pumps"
        });

        handleCacheUpdate([
          {
            args: {
              where: {
                journal_deleted_at: {
                  _is_null: true
                }
              }
            },
            relatedCacheKey: cache.keyOfEntity({
              __typename: "scenario_equipment",
              id: object.scenario_equipment_id
            }),
            relatedField: "xref_pumps"
          }
        ]);
      });
    }
  }
} as ModelsResolver;
